import React from 'react';
import { Helmet } from "react-helmet";

const TermsConditions = () => {
  return (
    <>
      <Helmet>
        <title>Haridem - Photography Studio Premium | Servizi Fotografici Professionali</title>
        <meta name="description" content="Haridem Photography Studio - Servizi fotografici professionali premium, ritratti artistici, gallerie contemporanee e attrezzatura fotografica di alta qualita" />
      </Helmet>

      <div style={{ padding: '40px 20px', maxWidth: '900px', margin: '0 auto', fontFamily: 'Arial, sans-serif', lineHeight: '1.8', color: '#333' }}>
      <h1 style={{ fontSize: '2.5rem', marginBottom: '10px', color: '#2a2a2a' }}>Termini e Condizioni</h1>
      <p style={{ marginBottom: '30px', color: '#666' }}>Ultimo aggiornamento: {new Date().toLocaleDateString('it-IT')}</p>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2a2a2a' }}>1. Accettazione dei Termini</h2>
        <p>Benvenuti in Haridem Photography Studio. Questi Termini e Condizioni ("Termini") regolano l'utilizzo del nostro sito web e dei nostri servizi fotografici professionali.</p>
        <p>Accedendo e utilizzando il sito www.haridem.com ("Sito") e i nostri servizi, accettate di essere vincolati da questi Termini. Se non accettate questi Termini, non utilizzate il nostro Sito o i nostri servizi.</p>
        <p>Ci riserviamo il diritto di modificare questi Termini in qualsiasi momento. Le modifiche entreranno in vigore al momento della pubblicazione sul Sito. È vostra responsabilità rivedere periodicamente questi Termini.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2a2a2a' }}>2. Definizioni</h2>
        <ul style={{ marginLeft: '20px' }}>
          <li><strong>"Noi", "Nostro", "Studio":</strong> si riferisce a Haridem Photography Studio</li>
          <li><strong>"Voi", "Cliente", "Utente":</strong> si riferisce alla persona o entità che utilizza i nostri servizi</li>
          <li><strong>"Servizi":</strong> include tutti i servizi fotografici, vendita di attrezzatura e servizi correlati</li>
          <li><strong>"Contenuti":</strong> include fotografie, testi, immagini, video e altri materiali</li>
          <li><strong>"Prodotti":</strong> attrezzatura fotografica e articoli venduti attraverso il Sito</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2a2a2a' }}>3. Servizi Offerti</h2>
        <h3 style={{ fontSize: '1.4rem', marginBottom: '10px', color: '#444' }}>3.1 Servizi Fotografici</h3>
        <p>Offriamo servizi fotografici professionali premium, tra cui:</p>
        <ul style={{ marginLeft: '20px' }}>
          <li>Ritratti artistici e professionali</li>
          <li>Fotografia di eventi</li>
          <li>Fotografia commerciale e aziendale</li>
          <li>Sessioni fotografiche personalizzate</li>
          <li>Post-produzione e ritocco professionale</li>
        </ul>

        <h3 style={{ fontSize: '1.4rem', marginBottom: '10px', marginTop: '20px', color: '#444' }}>3.2 Vendita di Attrezzatura</h3>
        <p>Vendiamo attrezzatura fotografica professionale di alta qualità attraverso il nostro Sito, incluse fotocamere, obiettivi, accessori e altro.</p>

        <h3 style={{ fontSize: '1.4rem', marginBottom: '10px', marginTop: '20px', color: '#444' }}>3.3 Galleria</h3>
        <p>Forniamo accesso a gallerie fotografiche contemporanee che mostrano il nostro lavoro e quello di artisti selezionati.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2a2a2a' }}>4. Registrazione e Account</h2>
        <p>Per utilizzare alcuni servizi, potrebbe essere necessario creare un account. Vi impegnate a:</p>
        <ul style={{ marginLeft: '20px' }}>
          <li>Fornire informazioni accurate, aggiornate e complete</li>
          <li>Mantenere la sicurezza delle vostre credenziali di accesso</li>
          <li>Notificarci immediatamente qualsiasi uso non autorizzato del vostro account</li>
          <li>Essere responsabili di tutte le attività svolte con il vostro account</li>
          <li>Avere almeno 18 anni di età</li>
        </ul>
        <p>Ci riserviamo il diritto di sospendere o terminare account che violano questi Termini.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2a2a2a' }}>5. Prenotazione e Pagamenti</h2>
        <h3 style={{ fontSize: '1.4rem', marginBottom: '10px', color: '#444' }}>5.1 Prenotazione Servizi Fotografici</h3>
        <ul style={{ marginLeft: '20px' }}>
          <li>Le prenotazioni devono essere effettuate tramite il Sito, email o telefono</li>
          <li>È richiesto un deposito del 30-50% per confermare la prenotazione</li>
          <li>Il saldo deve essere pagato prima o il giorno della sessione fotografica</li>
          <li>I prezzi sono indicati in Euro (€) e includono IVA dove applicabile</li>
        </ul>

        <h3 style={{ fontSize: '1.4rem', marginBottom: '10px', marginTop: '20px', color: '#444' }}>5.2 Acquisto di Prodotti</h3>
        <ul style={{ marginLeft: '20px' }}>
          <li>I prezzi dei prodotti sono soggetti a modifiche senza preavviso</li>
          <li>Il pagamento completo è richiesto al momento dell'ordine</li>
          <li>Accettiamo carte di credito/debito, PayPal e bonifici bancari</li>
          <li>Le transazioni sono elaborate tramite gateway di pagamento sicuri</li>
        </ul>

        <h3 style={{ fontSize: '1.4rem', marginBottom: '10px', marginTop: '20px', color: '#444' }}>5.3 Metodi di Pagamento</h3>
        <p>Accettiamo i seguenti metodi di pagamento:</p>
        <ul style={{ marginLeft: '20px' }}>
          <li>Carte di credito e debito (Visa, Mastercard, American Express)</li>
          <li>PayPal</li>
          <li>Bonifico bancario</li>
          <li>Contanti (solo per servizi in studio)</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2a2a2a' }}>6. Cancellazioni e Riprogrammazioni</h2>
        <h3 style={{ fontSize: '1.4rem', marginBottom: '10px', color: '#444' }}>6.1 Cancellazioni da Parte del Cliente</h3>
        <ul style={{ marginLeft: '20px' }}>
          <li><strong>Oltre 14 giorni prima:</strong> rimborso completo del deposito</li>
          <li><strong>7-14 giorni prima:</strong> rimborso del 50% del deposito</li>
          <li><strong>Meno di 7 giorni prima:</strong> nessun rimborso del deposito</li>
          <li><strong>Mancata presentazione:</strong> nessun rimborso</li>
        </ul>

        <h3 style={{ fontSize: '1.4rem', marginBottom: '10px', marginTop: '20px', color: '#444' }}>6.2 Riprogrammazioni</h3>
        <ul style={{ marginLeft: '20px' }}>
          <li>Le riprogrammazioni sono consentite con almeno 48 ore di preavviso</li>
          <li>È consentita una riprogrammazione gratuita</li>
          <li>Riprogrammazioni successive potrebbero comportare costi aggiuntivi</li>
        </ul>

        <h3 style={{ fontSize: '1.4rem', marginBottom: '10px', marginTop: '20px', color: '#444' }}>6.3 Cancellazioni da Parte dello Studio</h3>
        <p>In caso di circostanze impreviste (malattia, emergenze, condizioni meteorologiche avverse), ci riserviamo il diritto di riprogrammare. In tal caso, vi offriremo:</p>
        <ul style={{ marginLeft: '20px' }}>
          <li>Una nuova data concordata</li>
          <li>Rimborso completo se la riprogrammazione non è possibile</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2a2a2a' }}>7. Diritti d'Autore e Proprietà Intellettuale</h2>
        <h3 style={{ fontSize: '1.4rem', marginBottom: '10px', color: '#444' }}>7.1 Proprietà delle Fotografie</h3>
        <ul style={{ marginLeft: '20px' }}>
          <li>Haridem Photography Studio detiene tutti i diritti d'autore sulle fotografie create</li>
          <li>Voi ricevete una licenza non esclusiva per uso personale</li>
          <li>L'uso commerciale richiede una licenza separata e costi aggiuntivi</li>
          <li>Non potete vendere, distribuire o modificare le fotografie senza autorizzazione scritta</li>
        </ul>

        <h3 style={{ fontSize: '1.4rem', marginBottom: '10px', marginTop: '20px', color: '#444' }}>7.2 Diritti di Utilizzo dello Studio</h3>
        <p>Ci riserviamo il diritto di utilizzare le fotografie per:</p>
        <ul style={{ marginLeft: '20px' }}>
          <li>Portfolio professionale</li>
          <li>Promozione sui social media</li>
          <li>Materiale pubblicitario e marketing</li>
          <li>Esposizioni e gallerie</li>
          <li>Concorsi fotografici</li>
        </ul>
        <p>Se non desiderate che le vostre fotografie siano utilizzate pubblicamente, comunicatelo per iscritto al momento della prenotazione.</p>

        <h3 style={{ fontSize: '1.4rem', marginBottom: '10px', marginTop: '20px', color: '#444' }}>7.3 Contenuti del Sito</h3>
        <p>Tutti i contenuti presenti sul Sito (testi, immagini, loghi, grafica, design) sono protetti da copyright e di proprietà di Haridem Photography Studio. È vietata la riproduzione senza autorizzazione scritta.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2a2a2a' }}>8. Consegna e Spedizione</h2>
        <h3 style={{ fontSize: '1.4rem', marginBottom: '10px', color: '#444' }}>8.1 Fotografie Digitali</h3>
        <ul style={{ marginLeft: '20px' }}>
          <li>Le immagini digitali saranno consegnate tramite galleria online privata</li>
          <li>I tempi di consegna variano da 2 a 4 settimane dalla data della sessione</li>
          <li>Le immagini ad alta risoluzione sono fornite per il download</li>
          <li>L'accesso alla galleria è disponibile per 90 giorni</li>
        </ul>

        <h3 style={{ fontSize: '1.4rem', marginBottom: '10px', marginTop: '20px', color: '#444' }}>8.2 Prodotti Fisici</h3>
        <ul style={{ marginLeft: '20px' }}>
          <li>Spediamo in tutta Italia e in Europa</li>
          <li>I tempi di consegna variano da 3 a 10 giorni lavorativi</li>
          <li>Le spese di spedizione sono calcolate al checkout</li>
          <li>Forniamo tracking per tutti gli ordini</li>
          <li>La consegna gratuita è disponibile per ordini superiori a €200</li>
        </ul>

        <h3 style={{ fontSize: '1.4rem', marginBottom: '10px', marginTop: '20px', color: '#444' }}>8.3 Responsabilità per la Spedizione</h3>
        <p>Non siamo responsabili per ritardi causati da corrieri terzi. In caso di danneggiamento durante la spedizione, contattateci entro 48 ore dalla consegna.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2a2a2a' }}>9. Garanzie e Resi</h2>
        <h3 style={{ fontSize: '1.4rem', marginBottom: '10px', color: '#444' }}>9.1 Garanzia sui Prodotti</h3>
        <ul style={{ marginLeft: '20px' }}>
          <li>Tutti i prodotti sono coperti dalla garanzia del produttore</li>
          <li>I prodotti difettosi possono essere restituiti entro 30 giorni</li>
          <li>È richiesta la confezione originale e la prova d'acquisto</li>
        </ul>

        <h3 style={{ fontSize: '1.4rem', marginBottom: '10px', marginTop: '20px', color: '#444' }}>9.2 Diritto di Recesso</h3>
        <p>Conformemente al Codice del Consumo italiano, avete diritto di recedere dall'acquisto di prodotti fisici entro 14 giorni dalla consegna, senza necessità di specificare il motivo.</p>
        <ul style={{ marginLeft: '20px' }}>
          <li>I prodotti devono essere restituiti in condizioni originali</li>
          <li>Le spese di restituzione sono a vostro carico</li>
          <li>Il rimborso sarà elaborato entro 14 giorni dalla ricezione del reso</li>
        </ul>

        <h3 style={{ fontSize: '1.4rem', marginBottom: '10px', marginTop: '20px', color: '#444' }}>9.3 Servizi Fotografici</h3>
        <p>I servizi fotografici non sono soggetti al diritto di recesso una volta eseguiti. Tuttavia, garantiamo la vostra soddisfazione e lavoreremo con voi per risolvere eventuali problemi.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2a2a2a' }}>10. Responsabilità del Cliente</h2>
        <p>Durante le sessioni fotografiche, vi impegnate a:</p>
        <ul style={{ marginLeft: '20px' }}>
          <li>Arrivare puntualmente all'orario concordato</li>
          <li>Essere preparati secondo le indicazioni fornite</li>
          <li>Comportarvi in modo rispettoso verso il personale e le attrezzature</li>
          <li>Supervisionare i minori presenti</li>
          <li>Rispettare le norme di sicurezza dello studio</li>
          <li>Non consumare alcolici o sostanze che possano compromettere la sessione</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2a2a2a' }}>11. Limitazione di Responsabilità</h2>
        <p>Nella misura massima consentita dalla legge:</p>
        <ul style={{ marginLeft: '20px' }}>
          <li>Non siamo responsabili per danni indiretti, incidentali o consequenziali</li>
          <li>La nostra responsabilità totale è limitata all'importo pagato per il servizio o prodotto</li>
          <li>Non garantiamo che il Sito sia privo di errori o sempre disponibile</li>
          <li>Non siamo responsabili per la perdita di dati dovuta a problemi tecnici oltre il nostro controllo</li>
          <li>Non siamo responsabili per danni causati da vostro uso improprio dei servizi o prodotti</li>
        </ul>
        <p><strong>Eccezioni:</strong> Questa limitazione non si applica in caso di dolo, colpa grave o violazione di diritti fondamentali.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2a2a2a' }}>12. Forza Maggiore</h2>
        <p>Non saremo responsabili per inadempimenti dovuti a circostanze al di fuori del nostro ragionevole controllo, inclusi ma non limitati a:</p>
        <ul style={{ marginLeft: '20px' }}>
          <li>Disastri naturali (terremoti, alluvioni, incendi)</li>
          <li>Guerre, atti terroristici, rivolte civili</li>
          <li>Pandemie e emergenze sanitarie</li>
          <li>Interruzioni di servizi pubblici</li>
          <li>Scioperi e controversie di lavoro</li>
          <li>Guasti informatici o di comunicazione non imputabili a noi</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2a2a2a' }}>13. Privacy e Protezione dei Dati</h2>
        <p>Il trattamento dei vostri dati personali è regolato dalla nostra Informativa sulla Privacy, che costituisce parte integrante di questi Termini. Vi invitiamo a leggerla attentamente.</p>
        <p>Utilizzando i nostri servizi, acconsentite al trattamento dei vostri dati come descritto nell'Informativa sulla Privacy.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2a2a2a' }}>14. Condotta dell'Utente</h2>
        <p>Vi impegnate a NON:</p>
        <ul style={{ marginLeft: '20px' }}>
          <li>Utilizzare il Sito per scopi illegali o non autorizzati</li>
          <li>Violare diritti di proprietà intellettuale</li>
          <li>Trasmettere virus, malware o codice dannoso</li>
          <li>Tentare di accedere a aree non autorizzate del Sito</li>
          <li>Interferire con il funzionamento del Sito</li>
          <li>Impersonare altre persone o entità</li>
          <li>Raccogliere dati di altri utenti senza consenso</li>
          <li>Pubblicare contenuti offensivi, diffamatori o inappropriati</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2a2a2a' }}>15. Link a Siti Terzi</h2>
        <p>Il nostro Sito può contenere link a siti web di terze parti. Questi link sono forniti solo per comodità. Non abbiamo controllo su questi siti e non siamo responsabili per i loro contenuti, privacy policy o pratiche.</p>
        <p>L'inclusione di link non implica approvazione o associazione con tali siti.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2a2a2a' }}>16. Risoluzione delle Controversie</h2>
        <h3 style={{ fontSize: '1.4rem', marginBottom: '10px', color: '#444' }}>16.1 Legge Applicabile</h3>
        <p>Questi Termini sono regolati dalla legge italiana. Eventuali controversie saranno soggette alla giurisdizione esclusiva dei tribunali italiani competenti per territorio.</p>

        <h3 style={{ fontSize: '1.4rem', marginBottom: '10px', marginTop: '20px', color: '#444' }}>16.2 Risoluzione Amichevole</h3>
        <p>In caso di controversia, le parti si impegnano a cercare una risoluzione amichevole prima di intraprendere azioni legali. Vi invitiamo a contattarci per discutere eventuali problemi.</p>

        <h3 style={{ fontSize: '1.4rem', marginBottom: '10px', marginTop: '20px', color: '#444' }}>16.3 Mediazione</h3>
        <p>Prima di procedere con azioni legali, le parti possono concordare di sottoporre la controversia a mediazione secondo le regole della Camera di Commercio competente.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2a2a2a' }}>17. Modifiche ai Termini</h2>
        <p>Ci riserviamo il diritto di modificare questi Termini in qualsiasi momento. Le modifiche saranno pubblicate su questa pagina con una nuova data di "Ultimo aggiornamento".</p>
        <p>Per modifiche sostanziali, vi notificheremo tramite email o avviso prominente sul Sito. L'uso continuato dei servizi dopo le modifiche costituisce accettazione dei nuovi Termini.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2a2a2a' }}>18. Clausola di Salvaguardia</h2>
        <p>Se una disposizione di questi Termini viene ritenuta invalida o inapplicabile da un tribunale competente, tale disposizione sarà modificata e interpretata per raggiungere gli obiettivi di tale disposizione nella massima misura possibile. Le restanti disposizioni rimarranno pienamente valide ed efficaci.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2a2a2a' }}>19. Rinuncia</h2>
        <p>La mancata applicazione di qualsiasi disposizione di questi Termini non costituisce rinuncia a tale disposizione o a qualsiasi altro diritto ai sensi di questi Termini.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2a2a2a' }}>20. Integralità dell'Accordo</h2>
        <p>Questi Termini, insieme all'Informativa sulla Privacy e alla Politica di Rimborso, costituiscono l'intero accordo tra voi e Haridem Photography Studio riguardo all'utilizzo del Sito e dei servizi, sostituendo tutti gli accordi precedenti.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2a2a2a' }}>21. Contatti</h2>
        <p>Per domande o chiarimenti riguardo a questi Termini e Condizioni, potete contattarci:</p>
        <ul style={{ listStyle: 'none', marginLeft: '0', marginTop: '15px' }}>
          <li><strong>Haridem Photography Studio</strong></li>
          <li><strong>Email:</strong> <a href="mailto:haridem@hotmail.com">haridem@hotmail.com</a></li>
          <li><strong>Telefono:</strong> +39 XXX XXX XXXX</li>
          <li><strong>Indirizzo:</strong> [Inserire indirizzo completo]</li>
          <li><strong>Partita IVA:</strong> [Numero P.IVA]</li>
          <li><strong>Orari di assistenza:</strong> Lunedì - Venerdì, 9:00 - 18:00</li>
        </ul>
      </section>

      <div style={{ marginTop: '50px', padding: '20px', backgroundColor: '#f5f5f5', borderRadius: '5px' }}>
        <p style={{ margin: '0 0 10px 0', fontSize: '0.9rem', color: '#666' }}>
          <strong>Accettazione:</strong> Utilizzando il sito www.haridem.com e i nostri servizi, confermate di aver letto, compreso e accettato questi Termini e Condizioni.
        </p>
        <p style={{ margin: '0', fontSize: '0.9rem', color: '#666' }}>
          Se non accettate questi Termini, vi preghiamo di non utilizzare il nostro Sito o i nostri servizi.
        </p>
      </div>
    </div>
  
    </>);
};

export default TermsConditions;